import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { RegionDailyAverageAdminDto } from '@/backend/market'
import { RegionDailyAverageEntity } from '../../domain/entities/RegionDailyAverageEntity'

export class RegionDailyAverageModel extends RegionDailyAverageEntity {
  constructor(data: RegionDailyAverageAdminDto) {
    super()
    mapEntityProperties(this, data)
  }
}
